export default __webpack_public_path__ + "static/homeservice_1-812162d41ca81bdf9bb51877fc1fd19c.png";